import User from "admin/types/interfaces/user";
import queryString from "query-string";
import { SWRConfiguration } from "swr";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useUsers = (
  {
    searchQuery,
    activeOnly = false,
    enabled = true,
  }: { searchQuery?: string; activeOnly?: boolean; enabled?: boolean } = {},
  options?: SWRConfiguration
) => {
  const qs = queryString.stringify({
    with_auth0: true,
    page_size: 5000,
    // Using 5000 as a big-enough number to get all users for client-side pagination.
    // TODO: switch to server-side pagination.
    include_system_users: false,
    ...(searchQuery && { q: searchQuery }),
    ...(activeOnly && { active_only: activeOnly }),
  });
  const url = enabled ? `${VITE_ACCESS_CONTROLLER_API}/users?${qs}` : null;
  return useFetcher<User[]>(url, options);
};

export default useUsers;
